<div class="modal-header">
	<h4 class="modal-title">
		{{'labels.assign-resources' | translate}}
	</h4>
	<button
		type="button"
		class="close"
		aria-label="Close"
		(click)="dismiss()">
		<span aria-hidden="true">×</span>
	</button>
</div>

<div
	class="modal-body"
	ngbAutofocus>
	<div
		class="row"
		*ngIf="associableloading">
		<div class="col text-center">
			<app-loader [material]="false"></app-loader>
		</div>
	</div>

	<div class="row">
		<div
			class="col-md-6"
			*ngIf="!singlecompany">

			<div
				*ngIf="!singlecompany"
				class="col-md-3 form-group">
				<select
					class="form-control custom-select"
					[(ngModel)]="companyid"
					(change)="reloadEmployees()">
					<option [value]="0">{{'labels.choose-company' | translate}}</option>
					<option
						*ngFor="let p of partecipants"
						[value]="p.entityobj.id">
						{{p.entityobj.name}}
					</option>
				</select>

			</div>
		</div>

		<div class="col-md-6 form-group">

			<input
				type="text"
				class="form-control"
				placeholder="{{'labels.filter-employee' | translate}}"
				(keyup)="updateFilter($event)">
		</div>
	</div>

	<div
		class="company-filter"
		*ngIf="!associableloading">

	</div>

	<div
		class="table-responsive"
		*ngIf="!associableloading">

		<div class="row">
			<div
				class="col-md-6"
				*ngIf="!associableloading">

				<h4>
					{{'labels.associable-employee' | translate}}
				</h4>

				<ngx-datatable
					[tablefix]="datatable"
					#datatable
					class="bootstrap"
					[rows]="associablerows"
					[columnMode]="'flex'"
					[rowHeight]="'auto'"
					[headerHeight]="50"
					[footerHeight]="30"
					[externalPaging]="false"
					[externalSorting]="false"
					[loadingIndicator]="associableloading"
					[messages]="{
          emptyMessage: 'labels.empty-employees' | translate,
          totalMessage: 'labels.total' | translate
		}">

					<ngx-datatable-column
						prop="fname"
						[flexGrow]="1"
						[name]="'labels.fname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="lname"
						[flexGrow]="1"
						[name]="'labels.lname' | translate"
						[resizeable]="false">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							{{value}}
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						prop="docvalid"
						[flexGrow]="0.5"
						[name]="''"
						[resizeable]="false">
						<ng-template
							let-value="value"
							ngx-datatable-cell-template>
							<i
								*ngIf="value"
								container="body"
								ngbTooltip="{{'labels.docvalid' | translate}}"
								class="icon-valid feather icon-check-circle"></i>

							<i
								*ngIf="!value"
								container="body"
								ngbTooltip="{{'labels.docinvalid' | translate}}"
								class="icon-invalid feather icon-alert-octagon"></i>
						</ng-template>
					</ngx-datatable-column>

					<ngx-datatable-column
						[flexGrow]="1"
						[sortable]="false"
						[resizeable]="false"
						[cellClass]="'text-center'">
						<ng-template
							let-value="value"
							let-row="row"
							ngx-datatable-cell-template>
							<div class="icon-buttons">
								<a
									(click)="add(row)"
									class="link">
									<i
										container="body"
										ngbTooltip="{{'labels.add' | translate}}"
										class="feather icon-chevrons-right"></i>
								</a>
							</div>
						</ng-template>
					</ngx-datatable-column>
				</ngx-datatable>
			</div>
			<div
				class="col-md-6"
				*ngIf="!associateloading">
				<h4>
					{{'labels.associate-employee' | translate}}
				</h4>
				<form
					#editForm="ngForm"
					(ngSubmit)="editForm.valid && submit()">
					<ngx-datatable
						[tablefix]="datatable"
						#datatable
						class="bootstrap"
						[rows]="associaterows"
						[columnMode]="'flex'"
						[rowHeight]="'auto'"
						[headerHeight]="50"
						[footerHeight]="30"
						[externalPaging]="false"
						[externalSorting]="false"
						[loadingIndicator]="associateloading"
						[messages]="{
          emptyMessage: 'labels.empty-employees' | translate,
          totalMessage: 'labels.total' | translate
		}">

						<ngx-datatable-column
							[flexGrow]="1"
							[name]="'labels.fname' | translate"
							[resizeable]="false">
							<ng-template
								let-value="value"
								let-row="row"
								ngx-datatable-cell-template>
								{{row.employee.fname}}
							</ng-template>
						</ngx-datatable-column>

						<ngx-datatable-column
							[flexGrow]="1"
							[name]="'labels.lname' | translate"
							[resizeable]="false">
							<ng-template
								let-value="value"
								let-row="row"
								ngx-datatable-cell-template>
								{{row.employee.lname}}
							</ng-template>
						</ngx-datatable-column>

						<ngx-datatable-column
							[flexGrow]="2"
							[name]="'labels.projectrole' | translate"
							[resizeable]="false">
							<ng-template
								let-value="value"
								let-row="row"
								ngx-datatable-cell-template>
								<input
									[(ngModel)]="row.projectrole"
									#projectrole="ngModel"
									name="projectrole-{{row.id}}"
									required
									type="text"
									class="form-control"
									placeholder="{{ 'labels.projectrole' | translate }}"
									[ngClass]="{'is-invalid': editForm.submitted && projectrole.invalid}">
							</ng-template>
						</ngx-datatable-column>

						<ngx-datatable-column
							[flexGrow]="0.5"
							[name]="''"
							[resizeable]="false">
							<ng-template
								let-value="value"
								let-row="row"
								ngx-datatable-cell-template>
								<i
									*ngIf="row.employee.docvalid"
									container="body"
									ngbTooltip="{{'labels.docvalid' | translate}}"
									class="icon-valid feather icon-check-circle"></i>

								<i
									*ngIf="!row.employee.docvalid"
									container="body"
									ngbTooltip="{{'labels.docinvalid' | translate}}"
									class="icon-invalid feather icon-alert-octagon"></i>
							</ng-template>
						</ngx-datatable-column>

						<ngx-datatable-column
							[flexGrow]="1"
							[sortable]="false"
							[resizeable]="false"
							[cellClass]="'text-center'">
							<ng-template
								let-value="value"
								let-row="row"
								ngx-datatable-cell-template>
								<div class="icon-buttons">
									<a
										(click)="remove(row)"
										class="link">
										<i
											container="body"
											ngbTooltip="{{'labels.remove' | translate}}"
											class="feather icon-chevrons-left"></i>
									</a>
								</div>
							</ng-template>
						</ngx-datatable-column>
					</ngx-datatable>

					<div class="text-right mt-2">
						<button
							[disabled]="!associaterows?.length"
							type="submit"
							class="btn btn-primary">
							{{'labels.save' | translate}}
						</button>
					</div>
				</form>

			</div>
		</div>

	</div>
</div>
